import OMovieDetails from './o-movie-details';

export default OMovieDetails;